<template>
  <div class="page_mulu" >
    <div class="page_mulu">
       <h5 class="content">
         <h5 class="header page_header header_title_page page_bg_b">
           <span>附录</span>
         </h5>
         
         <div style="height:500px" class="appendix_img">
           <p class="text_title">中国本科专业学科门类</p>
           <img src="imgs/wayToStudyWays/report/appendix_img.png" />
         </div>         
        </h5>
      <div class="" v-for="(a, index) in appendix" :key="index">
        <div class="zhuanye_one content">
          <div
            class="small_title_box  career_page"
            :class="'color' + ++index"
          >
            <i class="zy_book" :class="'zy_book' + index"></i>
            <div class="small_titled">{{ a.num }}</div>
            <div class="line"></div>
            <div class="page_number">{{ a.twoName }}</div>
          </div>
        </div>

        <div class="" v-for="(d, index) in a.data" :key="index">
          <div class="num_warp content cc">
            <p>·{{ d.threeName }} {{ d.threeCode }}</p>
          </div>
          <div class="page_js content cc">
            <div class="page_zyjs page_bg_b">专业介绍</div>
            <ul>
              <li v-html="d.desc"></li>
            </ul>
          </div>
          <div class="page_js content cc">
            <div class="page_zyjs page_bg_o">知识能力</div>
            <p v-html="d.knowledgeAbility"></p>
            <!-- <ul>
              <li v-html="d.knowledgeAbility"></li>
            </ul> -->
          </div>
          <div class="page_js content cc">
            <div class="page_zyjs page_bg_g">主干课程</div>

            <ul>
              <li v-html="d.mainCourse"></li>
            </ul>
          </div>
          <div class="page_js content cc">
            <div class="page_zyjs page_bg_bl">就业方向</div>
            <ul>
              <li v-html="d.employmentDirection"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["appendix",'careerRecommend'],
  data() {
    return {};
  },
  mounted() {
    // this.drawLine()
   
  },

  methods: {
    
    drawLine() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("line"));
      myChart.setOption({});
    },
  },
};
</script>

<style scoped>
@import "./report.css";
.text_title{
  font-size: 20px;
  color: #000;
  text-align: center;
  line-height: 36px;
  margin: 10px 0;
  font-weight: 600;
  margin-bottom: 20px;
}
.appendix_img{
  margin: 0 auto;
  text-align: center;
  padding-top: 25px;
  box-sizing: border-box;
}
.blankPage {
  width: 100%;
  height: 1200px;
  visibility: hidden;
}
.zhuanye_one {
  margin-top: 30px;
}
.small_title_box {
  font-size: 16px;
  /* color: #3AB3C1; */
  line-height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 25px;
}

.small_title_box .small_titled {
  padding-right: 20px;
  font-weight: 700;
  padding-left: 15px;
  font-size: 20px;
  font-weight: 600;
}
.small_title_box .line {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-top: 2px dotted #aeadad;
  margin: auto 0;
}
.small_title_box .page_number {
  padding-left: 10px;
  /* font-size: 18px; */
  font-size: 20px;
  font-weight: 600;
}

h5.page_bg_o {
  background-color: #feae3b;
}
h5.page_bg_b {
  background-color: #19b1c4;
}
.page_co_o {
  color: #feae3b;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin: 30px 0;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.page_part2 .page_title_2 .arrow {
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  /* border-left: 14px solid #feae3b; */
  border-left: 14px solid #19b1c4;
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin-top: 20px;
}

#line {
  width: 100%;
  height: 300px;
}
.num_warp {
  margin: 0px 0 40px 0;
  padding: 10px;
  background: #f5f5f5;
  font-size: 16px;
  color: #2f2f2f;
  font-weight: 600;
}

.page_js {
  margin-bottom: 45px;
  height: auto;
  background: #f5f5f5;
  border-radius: 6px;
  padding: 30px 15px;
  box-sizing: border-box;
  position: relative;
}
.page_js ul li {
  text-indent: 2em;
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_js p {
  line-height: 2;
  font-size: 14px;
  color: #969696;
}
.page_zyjs {
  width: auto;
  padding: 0 15px;
  height: 30px;
  background: #3ab3c1;
  border-radius: 6px;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -15px;
}
.page_js .page_bg_b {
  background: #3ab3c1;
}
.page_js .page_bg_o {
  background: #feae3b;
}
.page_js .page_bg_bl {
  background: #00b3f0;
}
.page_js .page_bg_g {
  background: #aacf00;
}
.page_js2 .page_co_o {
  color: #feae3b;
}
.page_js2 {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.page_js2 .page_left,
.page_js2 .page_right {
  width: 334px;
  height: 163px;
}
.page_left {
  display: flex;
  background: url("../../../../../public/imgs/cepingreport/page_3_33.png")
    no-repeat;
  background-size: cover;
}
.page_right {
  display: flex;
  background: url("../../../../../public/imgs/cepingreport/page_3_34.png")
    no-repeat;
  background-size: cover;
}
.icon_warp {
  width: 110px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item_text ul {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 15px;
}
.item_text ul li {
  font-size: 14px;
  line-height: 2;
  font-weight: 500;
}
.icon_warp .mar_top {
  margin-top: 15px;
}
.icon_icon .cheng {
  display: inline-block;
  width: 42px;
  height: 42px;
  background: url("../../../../../public/imgs/cepingreport/page_3_31.png")
    no-repeat;
  background-size: cover;
}
.icon_icon .fa {
  display: inline-block;
  width: 42px;
  height: 42px;
  background: url("../../../../../public/imgs/cepingreport/page_3_32.png")
    no-repeat;
  background-size: cover;
}
</style>